import { lightThemeColors } from '../../tokens/light-colors';
import { baseTheme } from '../base-theme';
import { ThemeNames } from '../theme.types';
import { lightShadow } from '../../tokens/light-shadow';
import { popover, spinner, button, menu, tag, nav, drawer, backdrop, modal, checkbox, radio, notificationBanner, notification, input, textarea, tabs, toggle, table, severityTag, buttonGroup, } from '../../tokens';
import { select } from '../../tokens/component/select';
import { shadowScroll } from '../../tokens/component/shadow-scroll';
import { dates } from '../../tokens/component/dates';
const baseLightTheme = {
    ...baseTheme,
    name: ThemeNames.Light,
    colors: lightThemeColors,
    shadows: lightShadow,
};
export const lightTheme = {
    ...baseLightTheme,
    button: button(baseLightTheme),
    notificationBanner: notificationBanner(baseLightTheme),
    notification: notification(baseLightTheme),
    popover: popover(baseLightTheme),
    menu: menu(baseLightTheme),
    tag: tag(baseLightTheme),
    nav: nav(baseLightTheme),
    spinner,
    drawer: drawer(baseLightTheme),
    backdrop: backdrop(baseLightTheme),
    modal: modal(baseLightTheme),
    checkbox: checkbox(baseLightTheme),
    radio: radio(baseLightTheme),
    tabs: tabs(baseLightTheme),
    select: select(baseLightTheme),
    input: input(baseLightTheme),
    textarea: textarea(baseLightTheme),
    toggle: toggle(baseLightTheme),
    shadowScroll: shadowScroll(baseLightTheme),
    datePicker: dates(baseLightTheme),
    table: table(baseLightTheme),
    severityTag: severityTag(baseLightTheme),
    buttonGroup: buttonGroup(baseLightTheme),
};
//# sourceMappingURL=light-theme.js.map